import React, {useEffect} from 'react';
import {Link} from 'react-router-dom'
import CheckOutContainer from '../../container/CheckOutContainer';
import {useCartContext} from '../../context/cartContext'
import './cart.css'

//Componente del carrito una ves queiere terminar la compra!
const Cart = () => {
    const {items, removeItems, clearItems, total, getUnits} = useCartContext();
    
    useEffect(() => {
    }, [items])

    return (
        <>
            
            <section className="section section-xl bg-default">
                <div className="container">
                    <div className="table-custom-detail">
                        <table className="table-custom table-cart">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Nombre Producto</th>
                                    <th>Precio</th>
                                    <th>Cantidad</th>
                                    <th>Total</th>
                                    <th>Eliminar</th>
                                </tr>
                            </thead>
                            <tbody>
                                {items.map(x=> 
                                <tr key={x.id}>
                                    <td><img src={x.imag} alt="producto" className="img-table"/></td>
                                    <td><Link to={`/item/${x.id}`}>{x.description}</Link></td>
                                    <td>${x.precio}</td>
                                    <td>
                                        <div className="table-cart-stepper">
                                        {x.qty}
                                        </div>
                                    </td>
                                    <td>total</td>
                                    <td><button className="btn cart" onClick={() => removeItems(x.id)}><i className="far fa-trash-alt"></i></button></td>
                                </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div className="pieTabla">
                        <div className="group-md group-middle">
                            <div className="totalCheck">Total</div>
                            <div className="heading-3 font-weight-normal">${total()}</div>
                        </div>
                        <button className="btn cart" onClick={clearItems}>Borrar todo</button>

                        { items.length > 0 ?  <button type="button" className="btn cart" data-toggle="modal" data-target="#staticBackdrop" >CHECKOUT</button>
                        :
                        <Link to={'/'}><button className="btn cart">Ir Catalogo</button></Link>}
                        
                    </div>
                </div>
        </section>
       <CheckOutContainer items={items} total={total} getUnits={getUnits} clearItems={clearItems}/>
        
      </>
    )
}
export default Cart;